/* EVENTS */
export const GET_APPOINTMENTS = "GET_APPOINTMENTS"
export const GET_APPOINTMENTS_SUCCESS = "GET_APPOINTMENTS_SUCCESS"
export const GET_APPOINTMENTS_FAIL = "GET_APPOINTMENTS_FAIL"

export const GET_APPOINTMENTS_DETAILS = "GET_APPOINTMENTS_DETAILS"
export const GET_APPOINTMENTS_DETAILS_SUCCESS = "GET_APPOINTMENTS_DETAILS_SUCCESS"
export const GET_APPOINTMENTS_DETAILS_FAIL = "GET_APPOINTMENTS_DETAILS_FAIL"

export const ADD_NEW_APPOINTMENTS = "ADD_NEW_APPOINTMENTS"
export const ADD_APPOINTMENTS_SUCCESS = "ADD_APPOINTMENTS_SUCCESS"
export const ADD_APPOINTMENTS_FAIL = "ADD_APPOINTMENTS_FAIL"

export const UPDATE_APPOINTMENTS = "UPDATE_APPOINTMENTS"
export const UPDATE_APPOINTMENTS_SUCCESS = "UPDATE_APPOINTMENTS_SUCCESS"
export const UPDATE_APPOINTMENTS_FAIL = "UPDATE_APPOINTMENTS_FAIL"

export const DELETE_APPOINTMENTS = "DELETE_APPOINTMENTS"
export const DELETE_APPOINTMENTS_SUCCESS = "DELETE_APPOINTMENTS_SUCCESS"
export const DELETE_APPOINTMENTS_FAIL = "DELETE_APPOINTMENTS_FAIL"

export const CONFIRM_APPOINTMENTS = "CONFIRM_APPOINTMENTS"
export const CONFIRM_APPOINTMENTS_SUCCESS = "CONFIRM_APPOINTMENTS_SUCCESS"
export const CONFIRM_APPOINTMENTS_FAIL = "CONFIRM_APPOINTMENTS_FAIL"

export const COMPLETE_APPOINTMENTS = "COMPLETE_APPOINTMENTS"
export const COMPLETE_APPOINTMENTS_SUCCESS = "COMPLETE_APPOINTMENTS_SUCCESS"
export const COMPLETE_APPOINTMENTS_FAIL = "COMPLETE_APPOINTMENTS_FAIL"

export const ADD_REMARKS_APPOINTMENTS = "ADD_REMARKS_APPOINTMENTS"
export const ADD_REMARKS_APPOINTMENTS_SUCCESS = "ADD_REMARKS_APPOINTMENTS_SUCCESS"
export const ADD_REMARKS_APPOINTMENTS_FAIL = "ADD_REMARKS_APPOINTMENTS_FAIL"

export const RESET_APPOINTMENTS_STATE = 'RESET_APPOINTMENTS_STATE';
